import { createGtm } from '@gtm-support/vue-gtm'
import { createApp } from 'vue'
import App from '@/app.vue'
import 'bootstrap'
import i18n from '@/locales'
import {
  useDynamicLayout,
  type UseDynamicLayoutPluginOption
} from '@/plugins/use-dynamic-layout'
import router from '@/router'
import { piniaInstance } from '@/stores/pinia-instance'
import '~library/styles/app/style.scss'
import '~library/styles/app-custom/style.scss'
import { useEnv } from '~library/composables'

const { VITE_GTM_ID, VITE_GTM_DEBUG } = useEnv()

const app = createApp(App)
  .use(i18n)
  .use(piniaInstance)
  .use(router)
  .use<UseDynamicLayoutPluginOption>(useDynamicLayout, {
    router,
    layoutInFolder: true
  })

if (VITE_GTM_ID) {
  app.use(
    createGtm({
      id: VITE_GTM_ID,
      debug: VITE_GTM_DEBUG,
      vueRouter: router
    })
  )
}

app.mount('#app')

// 監聽 vite preloadError 並重新整理網站
window.addEventListener('vite:preloadError', () => {
  location.reload()
})
